import Component from '../core/Component'
import { getScrollTop } from '../services/Viewport/scroll'
import EventBus from '../core/EventBus'
import debounce from 'lodash/debounce'

const STATES = {
    PINNED_NAV: 'is-pinned-nav',
    PINNED: 'is-pinned',

    LEAVING_HEADER: 'is-leaving-header',
    ENTERING_HEADER: 'is-entering-header',
    LEAVING_PANEL: 'is-leaving-panel',
    ENTERING_PANEL: 'is-entering-panel',
}

export default class Header extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            navPanel: null,
            logo: null,
            inner: null,
            icons: null,
            navOpener: null,
            navigation: null,
            staticContainers: []
        }

        this.ref.staticContainers = [
            this.ref.navPanel,
            this.ref.logo,
            this.element,
            this.ref.icons
        ]

        this.navigation = null
        this.state = {
            isClearedForResize: true,
            isResizing: false,
            isPinned: false,
            navPanel: {
                documentTop: null,
                height: null
            },
            element: {
                documentTop: null,
            },
            window: {
                innerWidth: null
            }
        }

        this.handleAfterResize = debounce(this.handleAfterResize, 400)
    }

    prepare() {
        this.ref.navOpener.addEventListener('click', () => this.toggleNavigation())
        this.navigation = Component.getFromElement(this.ref.navigation)

        window.addEventListener('scroll', this.handleScroll, {
            passive: true
        })
        window.addEventListener('resize', this.handleResize)
        EventBus.on('dom:change', this.handleDomChange)
        this.resize()
    }

    destroy() {
        window.removeEventListener('scroll', this.handleScroll, {
            passive: true
        })
        window.removeEventListener('resize', this.handleResize)
        EventBus.off('dom:change', this.handleDomChange)
    }

    handleResize = () => {
        if (this.state.window.innerWidth === window.innerWidth) {
            return
        }
        this.state.isResizing = true
        this.clearForResize()
        this.handleAfterResize()
    }

    handleAfterResize = () => {
        this.state.isResizing = false
        this.resize()
    }

    handleDomChange = () => {
        this.state.isResizing = true
        this.clearForResize()
        this.handleAfterResize()
    }

    handleScroll = () => {
        const offset = getScrollTop()

        //tady je urco bug na tablet verzi, hlavicka je furt fixed, takze pri resize hodi documentTop aktualni scrollTop
        if (offset > this.state.navPanel.documentTop) {
            this.pinNavPanel()
        } else {
            this.unpinNavPanel()
        }

        if (offset > this.state.element.documentTop) {
            this.element.classList.add(STATES.PINNED)
        } else {
            this.element.classList.remove(STATES.PINNED)
        }

        EventBus.emit('Header:pin', { isPinned: this.state.isPinnedNav })
    }

    resize() {
        if (!this.state.isClearedForResize) {
            return
        }

        this.ref.staticContainers.forEach(el => {
            const rect = el.getBoundingClientRect()
            el.style.width = `${rect.width}px`
            el.style.height = `${rect.height}px`
        })

        const scrollTop = getScrollTop()
        const navPanelRect = this.ref.navPanel.getBoundingClientRect()
        const elementRect = this.element.getBoundingClientRect()
        this.state.navPanel.documentTop = scrollTop + navPanelRect.top
        this.state.element.documentTop = scrollTop + elementRect.top
        this.state.window.innerWidth = window.innerWidth
        this.state.isClearedForResize = false
    }

    toggleNavigation() {
        if (this.element.classList.toggle('is-nav-open')) {
            this.ref.navOpener.classList.add('is-active')
        } else {
            this.ref.navOpener.classList.remove('is-active')
        }

    }

    clearForResize() {
        if (this.state.isClearedForResize) {
            return
        }
        this.ref.staticContainers.forEach(el => {
            el.style.width = null
            el.style.height = null
        })
        this.state.isClearedForResize = true
        this.unpinNavPanel(true)
    }

    pinNavPanel(shouldSkipAnimation = false) {
        if (this.state.isPinnedNav || this.state.isResizing) {
            return
        }
        this.element.classList.add(STATES.PINNED_NAV)
        this.state.isPinnedNav = true

        this.ref.navPanel.children[0].style.paddingLeft = `${this.ref.logo.children[0].offsetWidth}px`
        this.ref.navPanel.children[0].style.paddingRight = `${this.ref.icons.children[0].offsetWidth}px`

        this.animateFromHeaderToPanel(shouldSkipAnimation)
    }

    unpinNavPanel(shouldSkipAnimation = false) {
        if (!this.state.isPinnedNav) {
            return
        }
        this.element.classList.remove(STATES.PINNED_NAV)
        this.state.isPinnedNav = false

        this.ref.navPanel.children[0].style.paddingLeft = null
        this.ref.navPanel.children[0].style.paddingRight = null

        this.animateFromPanelToHeader(shouldSkipAnimation)
    }

    animateFromHeaderToPanel(shouldSkipAnimation = false) {
        const state0 = () => {
            this.element.classList.add(STATES.LEAVING_HEADER)
        }
        const state1 = () => {
            this.element.classList.add(STATES.ENTERING_PANEL)
            this.element.classList.remove(STATES.LEAVING_HEADER)
            this.navigation?.checkListScroll()
        }
        const state2 = () => {
            this.element.classList.remove(STATES.ENTERING_PANEL)
        }

        if (shouldSkipAnimation) {
            state0()
            state1()
            state2()
        } else {
            state0()
            setTimeout(state1, 250)
            setTimeout(state2, 500)
        }
    }

    animateFromPanelToHeader(shouldSkipAnimation = false) {
        const state0 = () => {
            this.element.classList.add(STATES.LEAVING_PANEL)
        }
        const state1 = () => {
            this.element.classList.add(STATES.ENTERING_HEADER)
            this.element.classList.remove(STATES.LEAVING_PANEL)
            this.navigation?.checkListScroll()
        }
        const state2 = () => {
            this.element.classList.remove(STATES.ENTERING_HEADER)
        }

        if (shouldSkipAnimation) {
            state0()
            state1()
            state2()
        } else {
            state0()
            setTimeout(state1, 250)
            setTimeout(state2, 500)
        }
    }


}